import { stockLogTypes } from "@/helpers/get_constants";

export default {
  products: [],
  warehouses: null,
  stockLogs: null,
  stockLogTypes: {
    [stockLogTypes.TRANSFER_WAREHOUSE]: "Transferencia",
    [stockLogTypes.PURCHASE]: "Ingreso",
    [stockLogTypes.DECREASE]: "Merma",
    [stockLogTypes.SALE]: "Venta",
    [stockLogTypes.SALE_CANCELED]: "Venta anulada",
  },
};
